import oldTheme, { globalStyles as oldGlobalStyles } from 'theme/oldTheme';
import newTheme, { globalStyles as newGlobalStyles } from 'theme/newTheme';
import useIsNewLayoutPage from './useIsNewLayoutPage';

export default function useTheme() {
  const isNewLayoutPage = useIsNewLayoutPage();

  if (isNewLayoutPage) {
    return {
      theme: newTheme,
      globalStyles: newGlobalStyles,
    };
  }

  return {
    theme: oldTheme,
    globalStyles: oldGlobalStyles,
  };
}
